import React from "react";
import {
  Box,
  HStack,
  IconButton,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { BiX } from "react-icons/bi";

const SAMPLE_ID_COL_W = { base: "100%", md: "9.5rem" };

export default function SampleBox({
  index,
  data,
  onEditSample,
  onRemoveSample,
}) {
  return (
    <Box pt="1.5">
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={3}
        align={{ base: "stretch", md: "flex-start" }}
      >
        <HStack
          spacing={2}
          flexShrink={0}
          align="center"
          w={{ base: "full", md: "auto" }}
        >
          <Text fontWeight="bold" minW="1.25rem">
            {index + 1}.
          </Text>
          <Input
            type="text"
            value={"Sample #" + (index + 1)}
            focusBorderColor="primary.main"
            readOnly
            w={SAMPLE_ID_COL_W}
            maxW={SAMPLE_ID_COL_W}
            flexShrink={0}
          />
        </HStack>

        <VStack
          align="stretch"
          spacing={1}
          flex="1"
          minW={0}
          w={{ base: "full", md: "auto" }}
        >
          <Text fontSize="xs" fontWeight="semibold" color="gray.600">
            <Text as="span" color="red.500" aria-hidden>
              *
            </Text>{" "}
            Sampling location
          </Text>
          <Input
            type="text"
            value={data.value}
            onChange={(e) => {
              let trimVal = e.target.value.replace(/[^A-Z0-9_-\s]/gi, "");
              trimVal = trimVal.replace(/\s\s+/g, " ");
              trimVal = trimVal.substring(0, 30).toUpperCase();
              onEditSample(index, trimVal);
            }}
            placeholder="Enter location"
            focusBorderColor="primary.main"
            autoFocus
            w="full"
          />
        </VStack>

        <IconButton
          icon={<BiX />}
          bgColor="red.100"
          color="red"
          size="xs"
          fontSize="md"
          isRound
          flexShrink={0}
          alignSelf={{ base: "flex-end", md: "center" }}
          onClick={() => {
            onRemoveSample(index);
          }}
          isDisabled={index === 0}
        />
      </Stack>
    </Box>
  );
}
